import { REGION_ALL } from './constants';

export function formatDateForApi(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function buildDateList(startDate, endDate) {
  if (!startDate || !endDate) return [];
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);
  if (end < start) return [];
  const dayCount = Math.round((end - start) / MS_PER_DAY) + 1;
  const dates = [];
  for (let i = 0; i < dayCount; i += 1) {
    const day = new Date(start);
    day.setDate(start.getDate() + i);
    dates.push(formatDateForApi(day));
  }
  return dates;
}

export function applyClientFilters(routes, { region, market }) {
  let filtered = routes;
  if (region && region.value !== REGION_ALL) {
    filtered = filtered.filter((r) => r.market === region.value);
  }
  if (market && market.length > 0) {
    const selectedFCs = new Set(market.map((m) => m.value));
    filtered = filtered.filter((r) => selectedFCs.has(r.fulfillmentCenter));
  }
  return filtered;
}

function diffDaysInclusive(start, end) {
  const ms = end - start;
  return Math.floor(ms / (24 * 60 * 60 * 1000)) + 1;
}

export function validateRange(startDate, endDate, maxDays) {
  if (!startDate || !endDate) {
    return { valid: false, error: 'Start and end dates are required.' };
  }
  if (endDate < startDate) {
    return {
      valid: false,
      error: 'End date must be on or after start date.',
    };
  }
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);
  if (diffDaysInclusive(start, end) > maxDays) {
    return {
      valid: false,
      error: `Date range cannot exceed ${maxDays} days.`,
    };
  }
  return { valid: true };
}

export function getDefaultDateRange(days) {
  const startDate = new Date();
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + days);
  return { startDate, endDate };
}
